export enum InfoRichnessType {
  CONCISE = "concise",
  BALANCED = "balanced",
  EXPLANATORY = "explanatory",
}

export enum LvlOfExpTypes {
  EXPERT = "expert",
  ENTHUSIAST = "enthusiast",
  NOVICE = "novice",
}

export enum MarketCapTypes {
  ANY = "any",
  SMALL = "small",
  MEDIUM = "medium",
  LARGE = "large",
}

export const defaultPreferences = {
  information_richness: InfoRichnessType.BALANCED,
  expertise_level: LvlOfExpTypes.ENTHUSIAST,
  market_cap: MarketCapTypes.ANY,
  include_sectors: [],
  exclude_sectors: [],
};

export const initialSectorsArray = [
  "Communication Services",
  "Consumer Discretionary",
  "Consumer Staples",
  "Energy",
  "Financials",
  "Healthcare",
  "Industrials",
  "Materials",
  "Real Estate",
  "Technology",
  "Utilities",
];

export enum PendingQueryResponseStatus {
  IS_STREAMING = "IS_STREAMING",
  COMPLETED = "COMPLETED",
}
export type PendingQueryType = {
  chat_id: string | null;
  user_query: string | null;
  status: string;
};

export const loadingTexts = [
  "Working on the previous query...",
  "Gathering relevant information...",
  "Synthesizing key points...",
  "Retrieving last response...",
];
